



















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import EventResourceList from './EventResourceList'
import AddToCartTriggerModal from '@triggers/CheckoutWizard/AddToCartTriggerModal'
import RemoveFromCartTriggerModal from '@triggers/CheckoutWizard/RemoveFromCartTriggerModal'

settings =
  name: "EventFeed"
  components: {
    LoadingIndicator,
    EventResourceList,
    AddToCartTriggerModal,
    RemoveFromCartTriggerModal
  }
  resources:
    scanner:
      resourceName: 'scanner'
      slug: 'scanners/:eventFeedId/edit'
    events:
      resourceName: 'events'
      slug: 'scanners/:eventFeedId/events'
      infinityScroll: true
    shopping_cart:
      resourceName: 'shopping_cart'
      slug: 'event_schedules/:selectedEventScheduleId/shopping_cart'
      fetch: false
    event_requests:
      resourceName: 'event_request'
      slug: 'event_requests'
      fetch: false

  vue:
    props: ['eventFeedId']

    data: ->
      bulkActionResultItems: []
      selectedType: ''

    computed:
      lineItems: -> @shopping_cart?.line_items || []
      selectedEventScheduleId: -> @getAppSession('selectedEventSchedule')?.id
      isDetailsPage: -> @$route.name is 'EventFeedDetails'

    methods:
      onSave: -> @fetch('events')
      saveField: (fieldName) ->
        @clearDataForResourceKey('events')
        @saveItemField('prime.scanner', fieldName)

      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      hiAddToCartTrigger: (event_id, space_name, quantity=1) ->
        payload = { event_id, space_name, quantity }
        @triggerResource 'shopping_cart', 'add_to_cart', payload
      onShoppingCartAddToCart: ->
        @$refs.addToCartTrigger.close()
        @fetch('shopping_cart')

      removeFromCartTrigger: (event) ->
        cartItem = @lookupCartItemForEvent(event)
        payload =
          line_item_id: cartItem.id
        @$refs.eventFeedRemoveFromCartTrigger.fire(payload)
      onShoppingCartRemoveFromCart: ->
        @$refs.eventFeedRemoveFromCartTrigger.close()
        @fetch('shopping_cart')

      requestForMoreInfoTrigger: (event) ->
        @triggerResource 'event_requests', 'request_for_more_info', { event_id: event.id }
      onEventRequestsRequestForMoreInfo: ->
        @showFlash({ info: "Thanks for you interest. We'll let the organizer know that you want more info." })

      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      lookupCartItemForEvent: (event) ->
        @lineItems.find((lineItem) =>
          liEvent = @eventForLineItem(lineItem)
          isSameId = liEvent?.id is event.id
          isSameName = liEvent?.name is event.name
          return lineItem if isSameId and isSameName
        )

export default VueOptions.vue settings
